import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Dropdown, Button, DropdownContent, Icon } from 'shared/ui'
import styles from './styles.module.scss'
import { useBreakdownFilterContext } from '../../context/breakdownFilterContext'
import { BreakdownFilterTypesContent } from './BreakdownFilterTypesContent'
import { BreakdownFilterElement } from './BreakdownFilterElement'

type IBreakdownFilterEditorContentProps = {
  parentsDropdownId?: string[]
}

export const BreakdownFilterEditorContent: FC<IBreakdownFilterEditorContentProps> = observer(
  ({ parentsDropdownId }) => {
    const store = useBreakdownFilterContext()

    return (
      <DropdownContent noPadding className={styles.filterEditorDropdownContent}>
        <div className={styles.filtersContainer}>
          {store.breakdownFilterType && (
            <BreakdownFilterElement
              key={store.breakdownFilterType}
              type={store.breakdownFilterType}
              parentsDropdownId={parentsDropdownId}
            />
          )}

          {store.hasSelectedBreakdownItems && (
            <div className={styles.additionalFiltersContainer}>
              <Icon fontSize={16} padding={8} icon='moveTo' tertiary />
              <div className={styles.additionalFilters}>
                {store.additionalFilterTypes.length > 0 && (
                  <>
                    {store.additionalFilterTypes.map((type) => (
                      <BreakdownFilterElement
                        key={type}
                        type={type}
                        parentsDropdownId={parentsDropdownId}
                      />
                    ))}
                  </>
                )}
                {!store.hasAllAdditionalFiltersSelected && (
                  <Dropdown
                    ariaLabel={'Breakdown_FiltersDropdownContent'}
                    parentsDropdownId={parentsDropdownId}
                    iconButtonProps={{
                      size: 'medium',
                      fontSize: 20,
                      ariaLabel: 'Breakdown_FiltersDropdownContent_trigger',
                    }}
                    triggerComponent={() => (
                      <Button icon={'add'} contained={'secondary'} text={'Add additional filter'} />
                    )}
                    placement={'bottom-start'}
                    sizeTriggerButton={'medium'}
                    variantTriggerButton={'icon'}
                    customComponent={() => <BreakdownFilterTypesContent isAdditionalFilters />}
                  />
                )}
              </div>
            </div>
          )}
        </div>

        <div className={styles.actions}>
          <Button
            contained={'primary'}
            disabled={!store.hasSelectedBreakdownItems}
            onClick={store.onApply}
            text={'Apply'}
          />
          <Button
            contained={'secondary'}
            typeBtn={'text'}
            color={'var(--content-primary-secondary)'}
            onClick={store.clearAllFilters}
            text={'Clear filters'}
          />
        </div>
      </DropdownContent>
    )
  }
)
